/**
 * Marks a REMAINDER in an invoice list (COL-483): the second (or later)
 * invoice of a month whose offset invoice was closed while rent was still
 * coming in. It names the invoice it follows, so two invoices for the same
 * apartment and month read as one month's billing, not a duplicate. Renders
 * nothing for any other invoice.
 */
import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";
import { isRemainderInvoice } from "@/lib/offset-remainder";
import { managementRemainderOf } from "@/lib/management-invoice-lines";

export function RemainderInvoiceTag({
  row,
  className,
}: {
  row: {
    remainder_seq?: number | null;
    fee_basis?: Record<string, unknown> | null;
  };
  className?: string;
}) {
  const { t } = useLanguage();
  if (!isRemainderInvoice(row)) return null;
  const previous = managementRemainderOf(row);
  return (
    <span
      className={cn("text-xs font-normal text-muted-foreground", className)}
    >
      {previous
        ? t(
            "admin.payments.remainderFollows",
            "Remainder · follows {invoice}"
          ).replace("{invoice}", previous)
        : t("admin.payments.remainder", "Remainder")}
    </span>
  );
}
